import moment from 'moment';

export const getApiFormatDatetime = (datetime?: string) =>
  moment(datetime)
    .utc()
    .format('YYYY-MM-DD[T]HH:mm:ss+00:00');
